export var ActivePopupTypes;
(function (ActivePopupTypes) {
    ActivePopupTypes["action"] = "action";
    ActivePopupTypes["confirm"] = "confirm";
    ActivePopupTypes["info"] = "info";
})(ActivePopupTypes || (ActivePopupTypes = {}));
